var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gadget"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(false && _vm.showHideButton),expression:"false && showHideButton"}],staticClass:"hide_gadget",on:{"click":_vm.hideGadget}}),_vm._v(" "),_c('div',{staticClass:"gadget-contents"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d9da9f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/GadgetBase.vue
// module id = null
// module chunks = 